export default __webpack_public_path__ + "static/media/RW-Barein(360x600).50fef3f1.webp";